import React from 'react';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {logout} from '../../Context/AuthProvider/AuthProviderActions';
import {LoginLayout} from '../../Layouts/LoginLayout';
import {useNavigate} from 'react-router-dom';
import {EmptyState} from '../../Components/EmptyState';

import { UserOutlined } from '@ant-design/icons';
import {Button} from 'antd';
import {Auth0LogoutButton} from '../../Components/Form/Auth0LogoutButton';

export const ZendDeskLogOut : React.FunctionComponent = (_props) => {
    const {token} = useAuthState();
    const dispatch = useAuthDispatch();

    const queryParameters = new URLSearchParams(window.location.search);
    const email = queryParameters.get('email');
    const kind = queryParameters.get('kind');
    const message = queryParameters.get('message');
    const return_to = queryParameters.get('return_to');

    const navigate = useNavigate();

    const {loading} = useAuthState();

    React.useEffect( () => {
        if ( token !== undefined && token !== '' ){
            logout(dispatch);
        }
    }, [token, dispatch] );

    const title = React.useMemo( () => {
        switch (kind) {
            case 'error':
                return 'Error';
            case 'info':
                return 'Información';
            default:
                return 'Cerrando sesión';
        }
    }, [kind] );

    const subTitle = React.useMemo( () => {
        const  messageText = (email !== null) ? `Estimado ${email}` : undefined;
        return messageText;
    }, [email] );

    const returnToCallBack = React.useCallback( () => {
        if( return_to !== null ){
            window.location.replace(return_to);
        }
    }, [return_to] );

    const loginCallBack = React.useCallback( () => {
        let url = '/zendesk/sso';
        if( return_to !== null ){
            url = `${url}?return_to=${encodeURIComponent(return_to)}`;
        }

        navigate(url);
    }, [navigate, return_to] );

    return (
        <LoginLayout loginTitle={title} loginSubtitle={subTitle}>
            <EmptyState
                loading={ loading }
                icon={<UserOutlined />}
                message={(message !== null) ? message : 'Cerrando sesión'}
                EmptyStateSecondaryActions={
                    <>
                        {return_to !== null && (
                            <Button type="link" onClick={returnToCallBack}>Regresar</Button>
                        )}
                        <Button type="link" onClick={loginCallBack}>Iniciar Sesión</Button>
                        <Auth0LogoutButton />
                    </>
                }
            />
        </LoginLayout>
    );
};
